import { Box, type BoxProps, Hide } from '@chakra-ui/react';
import {
  gridConfig,
  Image,
  RecommendedBadge,
} from '@time-line/components/common';
import type { SanityImage } from '@time-line/components/types';
import { ProductFrontrowMdWidget } from 'components/product/ProductFrontrowMdWidget';
import { theme } from 'theme';

interface MediaProps extends BoxProps {
  media: SanityImage;
  isDoctorRecommended?: boolean;
  frontrowMDProductId?: string;
}

export function Media({
  media,
  isDoctorRecommended,
  frontrowMDProductId,
  ...props
}: MediaProps) {
  return (
    <Box
      pos="relative"
      borderRadius={gridConfig.gridBorderRadius}
      overflow="hidden"
      aspectRatio={{ base: '4 / 5', lg: 'unset' }}
      {...props}
    >
      <Image
        image={media}
        alt=""
        builderOptions={{ fill: true }}
        sizes={`(min-width: ${theme.breakpoints.lg}) 50vw, 100vw`}
        style={{ objectFit: 'cover', objectPosition: 'center' }}
        priority
        placeholder="blur"
        role="presentation"
      />

      {isDoctorRecommended && (
        <RecommendedBadge
          size="md"
          variant="light"
          pos="absolute"
          top={{ base: 'sm', lg: 'm' }}
          left={0}
          borderTopLeftRadius={0}
          borderBottomLeftRadius={0}
        />
      )}

      {frontrowMDProductId && (
        <Hide below="lg">
          <Box pos="absolute" bottom="m" left="0" maxW="380px">
            <ProductFrontrowMdWidget
              id={frontrowMDProductId}
              variant="sticker"
            />
          </Box>
        </Hide>
      )}
    </Box>
  );
}
